import React, { ReactNode } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { IdentityContextProvider } from "@react-beets/identity";
import { NotificationProvider } from "../../contexts";

const theme = createTheme({
  palette: {
    primary: {
      main: "#8B3040",
    },
  },
});

function Providers(props) {
  const { children } = props;
  const applicationName = process.env.REACT_APP_IDENTITY_APP || "rentbeets"
  const identityUrl =
    process.env.REACT_APP_IDENTITY_URL || "https://auth.rentbeets.com";

  return (
    <NotificationProvider>
      <ThemeProvider theme={theme}>
        <IdentityContextProvider
          applicationName={applicationName}
          url={identityUrl}
        >
          {children}
        </IdentityContextProvider>
      </ThemeProvider>
    </NotificationProvider>
  );
}

export default Providers;
